import type { CarrierDetails } from "../types";

export const MOCK_CARRIER_DETAILS: CarrierDetails = {
  rfpsInExtract: 1284,
  reps: 6,
  activeReps: 5,
  rules: 8,
  group: "Guardian Life",
  lastEdited: "Oct 14, 2026",
};
